import React, { Fragment, useState } from "react";
import ModalVideo from "react-modal-video";
import Header2 from "../../components/header/Header2";
import Scrollbar from "../../components/WhatsAppBtn/WhatsAppBtn";
import Footer from "../../components/footer/Footer";
import CtaSection from "../../components/CtaSection/CtaSection";
import Bg from "../../images/bg/page_bg01.jpg";
import icon from "../../images/icon/ser-01.svg";
import sImg1 from "../../images/icon/sd-icon01.svg";
import sImg2 from "../../images/icon/sd-icon02.svg";
import sImg3 from "../../images/icon/sd-icon03.svg";
import sImg4 from "../../images/icon/sd-icon04.svg";
import shape from "../../images/shape/sd-shape.png";
import sicon from "../../images/icon/check-icon.svg";
import bannerVPS from "../../images/banners/banner_vps.png";

const CloudVPSPage = (props) => {
  const [isOpen, setOpen] = useState(false);

  return (
    <Fragment>
      <div className="sco_agency">
        <Header2 />
        <main className="page_content service-single-page">
          <section
            className="page-title pt-200 pos-rel bg_img"
            style={{ backgroundImage: `url(${Bg})` }}
          >
            <div className="container">
              <div className="page-title-wrap sd-title-wrap">
                <div className="row mt-none-30 align-items-center justify-content-center">
                  <div className="col-lg-10 col-xl-8 mt-30">
                    <div className="page-title-box">
                      <span className="sub-title">
                        <img src={icon} alt="" /> Cloud VPS Somar
                      </span>
                      <h2 className="title">
                        Liberdade, Velocidade <br /> e Economia <br /> para quem
                        sabe o que está fazendo
                      </h2>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <div className="video pt-70 pb-65">
            <div className="container">
              <div className="xb-video sd-video image-only pos-rel">
                <img src={bannerVPS} alt="Email Banner" />
              </div>
            </div>
          </div>
          <div className="sd-ser-content_wrap pb-110">
            <div className="container">
              <div className="sd-ser-content">
                <h2 className="sd-title">
                  Cloud VPS Somar: Liberdade, Velocidade e Economia
                </h2>
                <p className="sd-content">
                  O Cloud VPS da Somar Cloud foi criado para quem sabe o que
                  está fazendo e precisa de um ambiente confiável, rápido e
                  acessível. Você recebe sua máquina virtual com IP dedicado em
                  minutos, pronta para uso, com total autonomia para instalar,
                  configurar e administrar do seu jeito.
                </p>
                <br />
                <p className="sd-content">
                  Sem camadas de gestão desnecessárias, sem backups automáticos
                  impostos, sem firewalls pré-configurados — você tem controle
                  total e paga apenas pela infraestrutura que realmente precisa.
                  Nossa proposta é simples: entregar recursos computacionais de
                  qualidade com liberdade técnica completa.
                </p>
                <br />
                <p className="sd-content">
                  <strong>
                    Ideal para desenvolvedores, agências, integradores e
                    projetos que exigem liberdade técnica com custo otimizado.
                  </strong>{" "}
                  Datacenter nacional garante menor latência e mais
                  estabilidade, suporte 24/7 em português focado em
                  infraestrutura, e preço justo sem extras desnecessários. Você
                  decide como usar sua VPS, nós garantimos que ela funcione
                  perfeitamente.
                </p>
              </div>
            </div>
          </div>
          <div className="sd-process_warp">
            <div className="container">
              <div className="sd-heading">
                <h2 className="sd-title">Como Funciona</h2>
                <p className="sd-content">
                  Processo simples e direto: você contrata, recebe sua VPS em
                  minutos e administra com total autonomia. Sem burocracia, sem
                  complicação, apenas a infraestrutura que você precisa.
                </p>
              </div>
              <div className="sd-process_inner ul_li">
                <div className="sd-process-item">
                  <div className="xb-item--icon">
                    <img src={sImg1} alt="" />
                  </div>
                  <h3 className="xb-item--title">Escolha seu Plano</h3>
                  <p className="xb-item--contact">
                    Selecione os recursos que você precisa sem pagar por extras
                    desnecessários.
                  </p>
                  <span className="xb-item--number">01</span>
                </div>
                <div className="sd-process-item">
                  <div className="xb-item--icon">
                    <img src={sImg2} alt="" />
                  </div>
                  <h3 className="xb-item--title">Provisionamento Rápido</h3>
                  <p className="xb-item--contact">
                    Sua VPS com IP dedicado fica pronta em poucos minutos.
                  </p>
                  <span className="xb-item--number">02</span>
                </div>
                <div className="sd-process-item">
                  <div className="xb-item--icon">
                    <img src={sImg3} alt="" />
                  </div>
                  <h3 className="xb-item--title">Configure do Seu Jeito</h3>
                  <p className="xb-item--contact">
                    Autonomia total para instalar, configurar e gerenciar sem
                    limitações.
                  </p>
                  <span className="xb-item--number">03</span>
                </div>
                <div className="sd-process-item">
                  <div className="xb-item--icon">
                    <img src={sImg4} alt="" />
                  </div>
                  <h3 className="xb-item--title">Suporte Quando Precisar</h3>
                  <p className="xb-item--contact">
                    Equipe 24/7 em português focada em infraestrutura
                    disponível.
                  </p>
                  <span className="xb-item--number">04</span>
                </div>
                <div className="sd-shape">
                  <img src={shape} alt="" />
                </div>
              </div>
            </div>
          </div>
          <div className="sd-service_wrap pt-115 pb-130">
            <div className="container">
              <div className="sd-ser-outcome">
                <div className="sd-heading">
                  <h2 className="sd-title">Destaques do Cloud VPS Somar</h2>
                  <p className="sd-content">
                    Infraestrutura confiável e acessível para profissionais que
                    precisam de liberdade técnica completa sem abrir mão de
                    qualidade e estabilidade.
                  </p>
                </div>
                <div className="sd-list-item ul_li">
                  <ul className="sd-ser-list list-unstyled">
                    <li>
                      <img src={sicon} alt="" />
                      Provisionamento rápido - VPS pronta em minutos
                    </li>
                    <li>
                      <img src={sicon} alt="" />
                      Autonomia completa - gerencie tudo sem limitações
                    </li>
                    <li>
                      <img src={sicon} alt="" />
                      IP dedicado incluso - conectividade direta sem NAT
                    </li>
                    <li>
                      <img src={sicon} alt="" />
                      Infraestrutura nacional - menor latência e mais
                      estabilidade
                    </li>
                  </ul>
                  <ul className="sd-ser-list list-unstyled">
                    <li>
                      <img src={sicon} alt="" />
                      Economia real - preço justo sem extras desnecessários
                    </li>
                    <li>
                      <img src={sicon} alt="" />
                      Suporte 24/7 em português - foco em infraestrutura
                    </li>
                    <li>
                      <img src={sicon} alt="" />
                      Sem camadas de gestão - controle total é seu
                    </li>
                    <li>
                      <img src={sicon} alt="" />
                      Recursos dedicados - performance consistente
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </main>
        <CtaSection />
      </div>
      <Footer />
      <Scrollbar />
      <ModalVideo
        channel="youtube"
        autoplay
        isOpen={isOpen}
        videoId="7e90gBu4pas"
        onClose={() => setOpen(false)}
      />
    </Fragment>
  );
};

export default CloudVPSPage;
